import React, { useState, useEffect } from "react";
import { Button, Table, Image, Row, Col, Skeleton, message, Spin } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import Layout from "../../../layout/Dashboard";
import firebase from "../../../config/FirebaseConfig";
import "./List.css";

export default function List() {
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [data, setData] = useState([]);
  const [userData,setUserData] = useState(null)
  const [selectedPlan,setSelectedPlan] = useState(null)
  const history = useHistory();

  useEffect(() => {
      firebase
      .firestore()
      .collection("chatPlan")
      .get()
      .then((snapshot)=>{
        let temp = [];
        snapshot.forEach((doc) => {
          temp.push({
            key: doc.id,
            ...doc.data(),
          });
        });
        const planList = temp
        firebase
        .firestore()
        .collection("transactions")
        .where("status", "==", "progress")
        .get()
        .then((snapshot) => {
          let temp = [];
          snapshot.forEach((doc) => {
            var dataDoc = doc.data()
            dataDoc.plan = planList.filter((plan)=>{
              return plan.key == dataDoc.plan
            })[0].name

            temp.push({
              key: doc.id,
              ...dataDoc,
            });
          });
          setData(temp);
          setLoading(false)
        })
        .catch((err) => {
          console.log(err);
        })
      })
  }, [actionLoading]);

  function formatDate(date) {
    return (
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear()
    );
  }

  const columns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (date) => {
        return <span>{formatDate(date.toDate())}</span>;
      },
    },
    {
      title: "Nama",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Plan",
      dataIndex: "plan",
      key: "plan",
    },
    {
      title: "Amount Transferred",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Receipt Images",
      dataIndex: "imgPath",
      key: "imgPath",
      render: (imgSrc) => {
        return (
          <Image
            src={imgSrc}
            alt="Receipt image"
            style={{
              height: 200,
              width: "auto",
            }}
            preview={true}
          />
        );
      },
    },
    {
      title: "Action",
      width: 180,
      render: (row) => {
        return (
          <Row>
            <Col>
              <Button
                onClick={() => {
                  setActionLoading(true);
                  firebase
                    .firestore()
                    .collection("transactions")
                    .doc(row.key)
                    .set(
                      {
                        status: "rejected",
                      },
                      { merge: true }
                    )
                    .then(() => {
                      setActionLoading(false);

                      message.success("Aksi berhasil");
                      setTimeout(() => {
                        history.push("/dashboard/plan");
                      }, 1000);
                    })
                    .catch((err) => {
                      setActionLoading(false);

                      console.log(err);
                      message.error("Terjadi kesalahan");
                    });
                }}
              >
                {actionLoading ? (
                  <Spin />
                ) : (
                  <CloseOutlined
                    style={{
                      fontSize: 18,
                      color: "red",
                    }}
                  />
                )}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={() => {
                  setActionLoading(true);
                  firebase
                    .firestore()
                    .collection("users")
                    .where("uid","==",row.userID)
                    .get()
                    .then((snapshot)=>{
                      var userDataTemp = []
                      snapshot.forEach((doc) => {
                        userDataTemp.push({
                          key: doc.id,
                          ...doc.data(),
                        });
                      });
                      var userData = userDataTemp[0]
                      firebase
                      .firestore()
                      .collection("chatPlan")
                      .where("name","==",row.plan)
                      .get()
                      .then((snapshot)=>{
                        var selectedPlanTemp = []
                        snapshot.forEach((doc) => {
                          selectedPlanTemp.push({
                            key: doc.id,
                            ...doc.data(),
                          });
                        });
                        var selectedPlan = selectedPlanTemp[0]
                        console.log("User Data",userData)
                        console.log("Selected Plan",selectedPlan)
                        console.log("calculate",parseInt(userData.consulTime) + parseInt(selectedPlan.time))
                        let temp = {};
                        // const planSplit = row.plan.toLowerCase()
                        // switch (planSplit) {
                        //   case "basic":
                            const dateNow = new Date();
                            temp = {
                              chatPlan: selectedPlan.key,
                              chatValid: firebase.firestore.Timestamp.fromDate(
                                new Date(dateNow.setDate(dateNow.getDate() + 30))
                              ),
                              consulTime: parseInt(userData.consulTime) + parseInt(selectedPlan.time)
                            };
                        //     break;
                        //   case "call":
                        //     temp = {
                        //       callPlan: planSplit[1],
                        //     };
                        //     break;
                        //   case "vidcall":
                        //     temp = {
                        //       vidcallPlan: planSplit[1],
                        //     };
                        //     break;
                        //   default:
                        //     break;
                        // }
                        console.log("TEMP DATA",temp)
                        Promise.all([
                          firebase
                            .firestore()
                            .collection("transactions")
                            .doc(row.key)
                            .set(
                              {
                                status: "accepted",
                              },
                              { merge: true }
                            ),
                          firebase
                            .firestore()
                            .collection("users")
                            .doc(row.userID)
                            .set(temp, {
                              merge: true,
                            }),
                        ]).then(() => {
                          setActionLoading(false);
                          message.success("Aksi berhasil");
                        });
                      })
                    })
                }}
              >
                {actionLoading ? (
                  <Spin />
                ) : (
                  <CheckOutlined
                    style={{
                      fontSize: 18,
                      color: "green",
                    }}
                  />
                )}
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  return (
    <div id="list-plan">
      <Layout>
        <div className="header">Plan Upgrade</div>
        <Skeleton loading={loading}>
          <Table columns={columns} dataSource={data} />
        </Skeleton>
      </Layout>
    </div>
  );
}
